export default __webpack_public_path__ + "static/media/Main_Story_Img_1200px.0b3961aa.png";